var map = {
	"./calvin.jpg": 53,
	"./east.jpg": 674,
	"./east_bak.jpg": 415,
	"./ke.jpg": 719,
	"./ke_bak.jpg": 910,
	"./ken.jpg": 938,
	"./rich.jpg": 263,
	"./trillion.jpg": 859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 309;